import {
    API_REQUEST,
    API_REQUEST_SUCCESS,
    API_REQUEST_FAILURE,
    API_RESET,
} from '../../constants/api';

/**
 * Generic api state shape:
 *
 *   state.api = {
 *     [key]: {
 *       loading: boolean,
 *       error:   string | null,
 *       data:    any | null,    // raw response.data from the server
 *     }
 *   }
 *
 * Components key into this slice via apiStateSelector(key) to read
 * loading / error / data without writing per-endpoint reducers.
 */
const initialState = {};

const setEntry = (state, key, patch) => ({
    ...state,
    [key]: {
        loading: false,
        error: null,
        data: null,
        ...(state[key] || {}),
        ...patch,
    },
});

export default (state = initialState, action) => {
    switch (action.type) {
        case API_REQUEST:
            return setEntry(state, action.key, { loading: true, error: null });

        case API_REQUEST_SUCCESS:
            return setEntry(state, action.key, {
                loading: false,
                error: null,
                data: action.data,
            });

        case API_REQUEST_FAILURE:
            return setEntry(state, action.key, {
                loading: false,
                error: action.error,
            });

        case API_RESET: {
            if (!state[action.key]) return state;
            const next = { ...state };
            delete next[action.key];
            return next;
        }

        default:
            return state;
    }
};
